import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

import { WerklijnContextMenuDetails } from '@/components/contextMenu/mwdContextMenu/types';
import { KnipOpdracht } from '@/queries/mutaties/opdrachten';
import { useMutaties } from '@/queries/mutaties/useMutaties';
import {
  ActiviteitVoorBewegingModel,
  mapArrayOfActiviteitVoorBeweging,
} from '@/queries/queryModels/activiteitenVoorBewegingModel';
import { useGetQuery } from '@/queries/useGetQuery';
import useClientState from '@/state/useClientState';

type KnipInputs = {
  knipActiviteit: ActiviteitVoorBewegingModel | undefined;
};
export const useKnippenDialog = (details: WerklijnContextMenuDetails, handleOpenChange: (open: boolean) => void) => {
  const { handleSubmit, control, reset, setValue, clearErrors } = useForm<KnipInputs>({
    mode: 'onSubmit',
  });
  const werklijnen = useClientState((state) => state.werklijnen);
  const [warningMessage, setWarningMessage] = useState<boolean>(false);
  const lockedWerklijnVersie = details.werklijnVersie;
  const werklijnVersieFromState = details.werklijnId && werklijnen[details.werklijnId]?.versie;

  useEffect(() => {
    const shouldShowWarning = werklijnVersieFromState && lockedWerklijnVersie !== werklijnVersieFromState;
    setWarningMessage(!!shouldShowWarning);
  }, [lockedWerklijnVersie, werklijnVersieFromState]);

  // get activiteiten voor beweging
  const {
    data: activiteitenVoorBewegingData,
    fetchData: fetchActiviteitenVoorBewegingData,
    clearData: clearActiviteitenVoorBewegingData,
  } = useGetQuery(mapArrayOfActiviteitVoorBeweging);

  // reset all values
  const resetDialog = (closeButtonCLick: boolean) => {
    if (closeButtonCLick) {
      handleOpenChange(false);
    }
    clearActiviteitenVoorBewegingData();
    reset();
    setValue('knipActiviteit', undefined);
  };

  const { knip } = useMutaties();

  const onSubmit = async (target: KnipInputs) => {
    const knipOpdracht: KnipOpdracht = {
      betrokkenWerklijn: {
        id: details.werklijnId,
        versie: werklijnVersieFromState as number,
      },
      inzetId: details.wleId ?? '',
      knipActiviteit: {
        beweging: {
          treinDatum: details.treindatum,
          treinnummer: Number.parseInt(details?.treinnummer ?? ''),
        },
        actueelGeplandeTijd: target.knipActiviteit?.actueelGeplandeTijd,
        dienstregelpunt: target.knipActiviteit?.dienstregelpunt,
        oorspronkelijkGeplandeTijd: target.knipActiviteit?.oorspronkelijkGeplandeTijd,
        soort: target.knipActiviteit?.soort,
      },
    };
    (async () => {
      const result = await knip(knipOpdracht);
      if (result.status === 'SUCCES') resetDialog(true);
    })();
  };

  return {
    handleSubmit,
    activiteitenVoorBewegingData,
    fetchActiviteitenVoorBewegingData,
    control,
    resetDialog,
    onSubmit,
    clearErrors,
    setValue,
    warningMessage,
  };
};
